module.exports = __webpack_public_path__ + "img/homePIc3.f17e33c0.png";